import { capitalized } from "../../../../core/formatters"
import { Series, SeriesOptions } from "../../../models/series"
import { SeriesDO, TimeValueDataObject } from "../../data-object/graph"
import { timeValueFromDataObject } from "./points-do.transforms"

const ensureValueFilter = (timeValue: TimeValueDataObject) => typeof timeValue.value === 'number'
const seriesNameFromDataObject = (s: SeriesDO) => s.name.split(delimitersRegex)[0].replace(/_/g, ' ')

const SERIES_NAME_DELIMITERS = ['_Protocol', '_CMC', '_TVL', '_MarketCap', '_USD','_Spot', '_AUM', '_RWA']
const delimitersRegex = new RegExp(SERIES_NAME_DELIMITERS.join('|'))

export const seriesFromDataObject = (seriesDO: SeriesDO, options: SeriesOptions): Series => {
    const name = capitalized(seriesNameFromDataObject(seriesDO))
    const debugBadTimePoints = seriesDO.raw_data.filter(p => typeof p.time !== 'string')
    //console.info('bad times ', debugBadTimePoints)
    const timeValues = seriesDO.raw_data.filter(ensureValueFilter).map(timeValueFromDataObject)
    //console.log(seriesDO.raw_data.length - timeValues.length, "invalid points value for ", name)
    // console.log(seriesDO.raw_data.length - series.map(s => s.).length, "invalid points value for ", name)
    return new Series(name, timeValues, options)
}
